import React from 'react';
import PropTypes from 'prop-types';
import 'moment-timezone';
import { getTenantConfig } from 'utils/tenant';

export default class FilterControls extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showGroupSessions: true,
      showSingleSessions: true,
      numberOfVisibleSlots: getTenantConfig('STUDENT_SCHEDULING_SLOT_DISPLAY_NUM') || 10
    };

    // We do this here to be able to test correctly
    // Source: https://github.com/airbnb/enzyme/issues/204
    this.onShowMoreSlotsButtonClick = this.onShowMoreSlotsButtonClick.bind(this);
    this.onSlotTypeDropdownChanged = this.onSlotTypeDropdownChanged.bind(this);
  }

  onShowMoreSlotsButtonClick() {
    const extraSlotsVisibleOnClick = getTenantConfig('STUDENT_SCHEDULING_SLOT_DISPLAY_NUM') || 10;
    this.setState({numberOfVisibleSlots: this.state.numberOfVisibleSlots + extraSlotsVisibleOnClick});
  }

    onSlotTypeDropdownChanged(e, { value }) {
    this.setState({
        showGroupSessions: value === 'bothSessionTypes' || value ===  'onlyGroupSessions',
        showSingleSessions: value === 'bothSessionTypes' || value === 'onlySingleSessions',
    });
  }

  render() {
    const extraProps = {
      numberOfVisibleSlots: this.state.numberOfVisibleSlots,
      showGroupSessions: this.state.showGroupSessions,
      showSingleSessions: this.state.showSingleSessions,
      onShowMoreSlotsButtonClick: this.onShowMoreSlotsButtonClick,
      onSlotTypeDropdownChanged: this.onSlotTypeDropdownChanged,
    };
    return React.cloneElement(this.props.children, extraProps);
  }
}

FilterControls.propTypes = {
  children: PropTypes.object.isRequired,

};
